export default {
  "Manage your team members and their roles": "إدارة أعضاء فريقك وأدوارهم",
  "Manager": "مدير فرع",
  "Manual": "يدوي",
  "Manual Adjustments": "التعديلات اليدوية",
  "Manual adjustment": "تعديل يدوي",
  "Margin:": "الهامش:",
  "Mark Ready": "تعليم كجاهز",
  "Mark Served": "تعليم كمُقدَّم",
  "Mark as Unpaid": "تعليم كغير مدفوع",
  "Mark fulfilled": "تعليم كمُنجز",
  "Match columns ·": "مطابقة الأعمدة ·",
  "Medium": "متوسط",
  "Menu": "القائمة",
  "Menu Item *": "عنصر القائمة *",
  "Menu Items": "عناصر القائمة",
  "Menu Management": "إدارة القائمة",
  "Menu Templates": "قوالب القائمة",
  "Menu categories": "تصنيفات القائمة",
  "Menu item deleted successfully": "تم حذف العنصر بنجاح",
  "Menu item stock": "مخزون عناصر القائمة",
  "Menu item {v0} successfully": "تم {v0} العنصر بنجاح",
  "Menu sections": "أقسام القائمة",
  "Message your customers": "راسل عملاءك",
  "Method:": "الطريقة:",
  "Metric": "المؤشر",
  "Milliliter": "مليلتر",
  "Min Stock": "الحد الأدنى للمخزون",
  "Min:": "الحد الأدنى:",
  "Minimal - Editorial Lookbook": "بسيط - كتالوج تحريري",
  "Minimal - Swiss Tabs": "بسيط - تبويبات سويسرية",
  "Minimum Threshold": "الحد الأدنى",
  "Modern - App Style": "عصري - بأسلوب التطبيقات",
  "Modern cards with gradient accents": "بطاقات عصرية بلمسات متدرجة",
  "Modified data exported": "تم تصدير البيانات المعدلة",
  "Modifiers:": "الإضافات:",
  "Monthly": "شهري",
  "Monthly Salary (MAD)": "الراتب الشهري (MAD)",
  "MySQL Database": "قاعدة بيانات MySQL",
  "NEW": "جديد",
  "NORMAL": "عادي",
  "NOTHING MATCHES. TRY ANOTHER SEARCH.": "لا توجد نتائج. جرّب بحثًا آخر.",
  "Name": "الاسم",
  "Name (optional)": "الاسم (اختياري)",
  "Name and phone are required": "الاسم والهاتف مطلوبان",
  "Name and price are required": "الاسم والسعر مطلوبان",
  "Name and price are required. Prices use your business currency. Missing categories become “Uncategorized”. Existing SKU or same name within a category is skipped. Imported items are available immediately. Variants and stock quantities are not imported.": "الاسم والسعر مطلوبان. تُستخدم عملة نشاطك للأسعار. التصنيفات غير الموجودة تصبح \"غير مصنف\". يتم تخطي رموز SKU الموجودة أو الأسماء المكررة داخل التصنيف نفسه. تكون العناصر المستوردة متاحة فورًا. لا يتم استيراد الخيارات وكميات المخزون.",
  "Name your store": "سمِّ متجرك",
  "Name: A to Z": "الاسم: من أ إلى ي",
  "Neon drinks board: pick a category, see only that list": "لوحة مشروبات نيون: اختر تصنيفًا لعرض قائمته فقط",
  "Neon gradient • Bold rounded type • Moody": "تدرج نيون • خطوط عريضة دائرية • أجواء ليلية",
  "Net Cash": "صافي النقد",
  "New": "جديد",
  "New (0-5min)": "جديد (0-5 دقائق)",
  "New (30 days)": "جديد (30 يومًا)",
  "New campaign": "حملة جديدة",
  "New column added": "تمت إضافة عمود جديد",
  "New drop is live.": "الإصدار الجديد متاح الآن.",
  "New goodies are coming soon ✨": "منتجات جديدة قادمة قريبًا ✨",
  "New here? ": "جديد هنا؟ ",
  "New order {order_code} received!": "تم استلام طلب جديد {order_code}!",
  "New order: {order_code}": "طلب جديد: {order_code}",
  "New order: {order_code} - Table {table_number}": "طلب جديد: {order_code} - طاولة {table_number}",
  "New orders": "طلبات جديدة",
  "New plan": "خطة جديدة",
  "New row added": "تمت إضافة صف جديد",
  "New to Rawaj Business?": "جديد على رواج بزنس؟",
  "Next image": "الصورة التالية",
  "Next month": "الشهر التالي",
  "Next payment": "الدفعة القادمة",
  "No Name": "بدون اسم",
  "No PIN": "بدون PIN",
  "No Recipes Found": "لا توجد وصفات",
  "No Restaurants Yet": "لا توجد مطاعم بعد",
  "No SKU": "بدون SKU",
  "No Table": "بدون طاولة",
  "No account with this number yet.": "لا يوجد حساب بهذا الرقم بعد.",
  "No active orders in the kitchen at the moment. New orders will appear here automatically.": "لا توجد طلبات نشطة في المطبخ حاليًا. ستظهر الطلبات الجديدة هنا تلقائيًا.",
  "No activity logs found": "لا توجد سجلات نشاط",
  "No add-ons to buy. Every business gets the full toolkit from day one.": "لا إضافات مدفوعة. يحصل كل نشاط على جميع الأدوات من اليوم الأول.",
  "No backups available": "لا توجد نسخ احتياطية",
  "No bookings here yet.": "لا توجد حجوزات هنا بعد.",
  "No campaigns sent yet": "لم تُرسل أي حملة بعد",
  "No card or bank account linked yet.": "لم يتم ربط بطاقة أو حساب بنكي بعد.",
  "No cash reconciliation data available": "لا توجد بيانات لتسوية النقد",
  "No categories found": "لا توجد تصنيفات",
  "No customers yet": "لا يوجد عملاء بعد",
  "No daily sales data available": "لا توجد بيانات للمبيعات اليومية",
  "No data available for Excel view": "لا توجد بيانات لعرض Excel",
  "No data available. Click \"Refresh Data\" to load the report.": "لا توجد بيانات. انقر على \"تحديث البيانات\" لتحميل التقرير.",
  "No employees found": "لا يوجد موظفون",
  "No history found": "لا يوجد سجل",
  "No inventory items": "لا توجد عناصر مخزون",
  "No inventory usage data available": "لا توجد بيانات لاستهلاك المخزون",
  "No invoices yet": "لا توجد فواتير بعد",
  "No invoices yet.": "لا توجد فواتير بعد.",
  "No items available in this category": "لا توجد عناصر في هذا التصنيف",
  "No items ordered": "لم يتم طلب أي عنصر",
  "No loyalty data yet": "لا توجد بيانات ولاء بعد",
  "No matches - try another word 💭": "لا نتائج - جرّب كلمة أخرى 💭",
  "No matches yet": "لا توجد نتائج بعد",
  "No menu items found": "لا توجد عناصر في القائمة",
  "No order data available": "لا توجد بيانات طلبات",
  "No order matches PIN {pin}.": "لا يوجد طلب يطابق رمز PIN ‏{pin}.",
  "No orders": "لا توجد طلبات",
  "No orders found": "لا توجد طلبات",
  "No orders yet": "لا توجد طلبات بعد",
  "No orders yet - share your store link to start selling.": "لا توجد طلبات بعد - شارك رابط متجرك لتبدأ البيع.",
  "No payment methods data available": "لا توجد بيانات لطرق الدفع",
  "No pending payments": "لا توجد مدفوعات معلقة",
  "No plan yet": "لا توجد خطة بعد",
  "No plans are available yet. Contact support.": "لا توجد خطط متاحة بعد. تواصل مع الدعم.",
  "No plans yet - create one above.": "لا توجد خطط بعد - أنشئ واحدة أعلاه.",
  "No product data available": "لا توجد بيانات منتجات",
  "No products are tracking stock yet.": "لا توجد منتجات تتتبع المخزون بعد.",
  "No recent orders": "لا توجد طلبات حديثة",
  "No recent orders found.": "لم يتم العثور على طلبات حديثة.",
  "No reservations here yet. Customers can reserve from your public website.": "لا توجد حجوزات بعد. يمكن للعملاء الحجز من موقعك.",
  "No rewards available yet for this balance.": "لا توجد مكافآت متاحة لهذا الرصيد بعد.",
  "No sales range data available": "لا توجد بيانات مبيعات لهذه الفترة",
  "No sales yet.": "لا توجد مبيعات بعد.",
  "No services are available for booking right now.": "لا توجد خدمات متاحة للحجز حاليًا.",
  "No services match your search.": "لا توجد خدمات تطابق بحثك.",
  "No services match your search. Try another name.": "لا توجد خدمات تطابق بحثك. جرّب اسمًا آخر.",
  "No services yet. Add your first bookable service.": "لا توجد خدمات بعد. أضف أول خدمة قابلة للحجز.",
  "No stock items found": "لا توجد عناصر مخزون",
  "No subscription": "لا يوجد اشتراك",
  "No table turnover data available": "لا توجد بيانات لدوران الطاولات",
  "No tables found": "لا توجد طاولات",
  "No times left on this day - try another date.": "لم تتبقَّ أوقات في هذا اليوم - جرّب تاريخًا آخر.",
  "No times on this day. Choose another date.": "لا توجد أوقات في هذا اليوم. اختر تاريخًا آخر.",
  "No top items data available": "لا توجد بيانات للعناصر الأكثر مبيعًا",
  "No upcoming blocked dates.": "لا توجد تواريخ محظورة قادمة.",
  "No variants": "لا توجد خيارات",
  "No variants added yet": "لم تتم إضافة خيارات بعد",
  "No {v0} orders at the moment.": "لا توجد طلبات {v0} حاليًا.",
  "No.": "رقم",
  "No. Start with a free trial and choose a monthly plan when you are ready to go live.": "لا. ابدأ بتجربة مجانية واختر خطة شهرية عندما تكون جاهزًا للإطلاق.",
  "None assigned": "لم يُعيَّن",
  "Normal": "عادي",
  "Normal (6-15min)": "عادي (6-15 دقيقة)",
  "Not included": "غير مشمول",
  "Not paid yet": "لم يُدفع بعد",
  "Not set": "غير محدد",
  "Note": "ملاحظة",
  "Note:": "ملاحظة:",
  "Notes (optional)": "ملاحظات (اختياري)",
  "Nothing booked yet - share your store link so customers can book.": "لا توجد حجوزات بعد - شارك رابط متجرك ليتمكن العملاء من الحجز.",
  "Nothing here yet - try another collection.": "لا شيء هنا بعد - جرّب تشكيلة أخرى.",
  "OR": "أو",
  "ORDER": "الطلب",
  "ORDER DETAILS": "تفاصيل الطلب",
  "ORDER ITEMS": "عناصر الطلب",
  "ORDER RECEIVED": "تم استلام الطلب",
  "Office / Coworking": "مكتب / مساحة عمل مشتركة",
  "Omakase & à la carte": "أوماكاسي وطلبات منفردة",
  "On the menu": "في القائمة",
  "One platform, every kind of business": "منصة واحدة لكل أنواع الأنشطة",
  "Online Store": "متجر إلكتروني",
  "Online payments are not set up on this platform yet. Contact support to activate your subscription.": "الدفع الإلكتروني غير مفعّل على المنصة بعد. تواصل مع الدعم لتفعيل اشتراكك.",
  "Online reservations are closed": "الحجز عبر الإنترنت مغلق",
  "Online stores": "المتاجر الإلكترونية",
  "Online table reservations": "حجز الطاولات عبر الإنترنت",
  "Only {count} left": "بقي {count} فقط",
  "Open cart": "فتح السلة",
  "Open full size": "فتح بالحجم الكامل",
  "Open late": "مفتوح حتى وقت متأخر",
  "Open menu": "فتح القائمة",
  "Open sidebar": "فتح الشريط الجانبي",
  "Opening secure payment…": "جارٍ فتح صفحة الدفع الآمن…",
  "Opening...": "جارٍ الفتح...",
  "Operating Mode": "وضع التشغيل",
  "Operating mode changed to {mode}": "تم تغيير وضع التشغيل إلى {mode}",
  "Option:": "الخيار:",
  "Options": "الخيارات",
  "Options (Optional)": "الخيارات (اختياري)",
  "Or import a Google Sheet": "أو استورد Google Sheet",
  "Order": "الطلب",
  "Order #": "طلب رقم ",
  "Order #:": "رقم الطلب:",
  "Order Created": "تم إنشاء الطلب",
  "Order Deductions": "خصومات الطلبات",
  "Order Details": "تفاصيل الطلب",
  "Order Instructions": "تعليمات الطلب",
  "Order Items": "عناصر الطلب",
  "Order PIN": "رمز PIN للطلب",
  "Order Receipt": "إيصال الطلب",
  "Order Ref:": "مرجع الطلب:",
  "Order Reference": "مرجع الطلب",
  "Order Status": "حالة الطلب",
  "Order Type": "نوع الطلب",
  "Order acknowledged and cooking started": "تم استلام الطلب وبدأ التحضير",
  "Order cancelled": "تم إلغاء الطلب",
  "Order code, customer name, or PIN": "رمز الطلب أو اسم العميل أو PIN",
  "Order completed successfully! {v0}": "تم إكمال الطلب بنجاح! {v0}",
  "Order confirmed": "تم تأكيد الطلب",
  "Order found!": "تم العثور على الطلب!",
  "Order from your phone": "اطلب من هاتفك",
  "Order marked as completed": "تم تعليم الطلب كمكتمل",
  "Order marked as fulfilled": "تم تعليم الطلب كمُنجز",
  "Order more": "اطلب المزيد",
  "Order not found": "لم يتم العثور على الطلب",
  "Order not found with the provided code or PIN": "لم يتم العثور على طلب بالرمز أو PIN المدخل",
  "Order reference": "مرجع الطلب",
  "Order status updated to {action}": "تم تحديث حالة الطلب إلى {action}",
  "Order status updated to {newStatus}": "تم تحديث حالة الطلب إلى {newStatus}",
  "Order {order_code} cancelled": "تم إلغاء الطلب {order_code}",
  "Order {order_code} confirmed - Start preparing!": "تم تأكيد الطلب {order_code} - ابدأ التحضير!",
  "Order:": "الطلب:",
  "Order: #": "الطلب: #",
  "Orders": "الطلبات",
  "Orders Today": "طلبات اليوم",
  "Orders by Status": "الطلبات حسب الحالة",
  "Our Menu": "قائمتنا",
  "Out of stock": "نفد المخزون",
  "Out-of-stock shown automatically": "عرض نفاد المخزون تلقائيًا",
  "Outstanding balance (all members)": "الرصيد القائم (جميع الأعضاء)",
  "Override price (e.g. 25.00)": "سعر مخصص (مثال: 25.00)",
  "Overview": "نظرة عامة",
  "Owner Portal": "بوابة المالك",
  "PAID": "مدفوع",
  "PAYMENT": "الدفع",
  "PDF receipt": "إيصال PDF",
  "PENDING": "قيد الانتظار",
  "PIN": "PIN",
  "PIN (4 digits)": "PIN (4 أرقام)",
  "PIN:": "PIN:",
  "PNG, JPG, GIF, WebP up to": "PNG أو JPG أو GIF أو WebP حتى",
  "PNG, JPG, WebP, GIF up to 5MB": "PNG أو JPG أو WebP أو GIF حتى 5 ميغابايت",
  "POS": "نقطة البيع",
  "POS, kitchen display and receipts": "نقطة بيع وشاشة مطبخ وإيصالات",
  "PREPARING": "قيد التحضير",
  "PRIORITY": "أولوية",
  "Pack": "علبة",
  "Page not found": "الصفحة غير موجودة",
  "Paid": "مدفوع",
  "Paid:": "المدفوع:",
  "Parties of 1–30 guests": "مجموعات من 1 إلى 30 ضيفًا",
  "Password": "كلمة المرور",
  "Password (min. 6 characters)": "كلمة المرور (6 أحرف على الأقل)",
  "Password *": "كلمة المرور *",
  "Password changed successfully": "تم تغيير كلمة المرور بنجاح",
  "Password is required for new employees": "كلمة المرور مطلوبة للموظفين الجدد",
  "Pause theme": "إيقاف الثيم مؤقتًا",
  "Pay by bank transfer": "الدفع بالتحويل البنكي",
  "Pay by card": "الدفع بالبطاقة",
  "Pay by card or link your bank account securely with Stripe. We never see your full card or account number.": "ادفع بالبطاقة أو اربط حسابك البنكي بأمان عبر Stripe. لا نطّلع أبدًا على رقم بطاقتك أو حسابك كاملًا.",
  "Pay now": "ادفع الآن",
  "Payment": "الدفع",
  "Payment Already Confirmed": "تم تأكيد الدفع مسبقًا",
  "Payment Method": "طريقة الدفع",
  "Payment Methods": "طرق الدفع",
  "Payment Status": "حالة الدفع",
  "Payment Status:": "حالة الدفع:",
  "Payment amount must be at least the order total": "يجب ألا يقل المبلغ المدفوع عن إجمالي الطلب",
  "Payment confirmed! Order sent to kitchen": "تم تأكيد الدفع! أُرسل الطلب إلى المطبخ",
  "Payment confirmed! Order sent to kitchen.": "تم تأكيد الدفع! أُرسل الطلب إلى المطبخ.",
  "Payment method": "طريقة الدفع",
  "Payment methods loaded successfully": "تم تحميل طرق الدفع بنجاح",
  "Payment methods saved": "تم حفظ طرق الدفع",
  "Payment overdue": "الدفع متأخر",
  "Payment received": "تم استلام الدفع",
  "Payment received - thank you!": "تم استلام الدفع - شكرًا لك!",
  "Payment recorded: {totalPaid} MAD": "تم تسجيل الدفع: {totalPaid} MAD",
  "Payment status updated": "تم تحديث حالة الدفع",
  "Payment verified - order marked as paid": "تم التحقق من الدفع - الطلب مدفوع",
  "Payments": "المدفوعات",
  "Pending": "قيد الانتظار",
  "Pending Orders": "الطلبات المعلقة",
  "Pending Payments": "المدفوعات المعلقة",
  "Percent off": "نسبة الخصم",
  "Period": "الفترة",
  "Phone": "الهاتف",
  "Phone Number": "رقم الهاتف",
  "Phone Number (Optional)": "رقم الهاتف (اختياري)",
  "Phone number": "رقم الهاتف",
  "Photo {n}": "صورة {n}",
  "Photos added": "تمت إضافة الصور",
  "Pick the kind of business you're building — you'll get the right tools for it.": "اختر نوع النشاط الذي تبنيه — وستحصل على الأدوات المناسبة له.",
  "Pick what kind of business you run": "اختر نوع نشاطك",
  "Pick your business type and get the tools and website template made for it.": "اختر نوع نشاطك واحصل على الأدوات وقالب الموقع المصمم له.",
  "Pickup": "استلام",
  "Piece": "قطعة",
  "Pinterest": "بنترست",
  "Place order": "تأكيد الطلب",
  "Placing your order…": "جارٍ إرسال طلبك…",
  "Plan": "الخطة",
  "Plan & pricing": "الخطة والتسعير",
  "Plan assigned": "تم تعيين الخطة",
  "Plan created": "تم إنشاء الخطة",
  "Plan name (e.g. Standard)": "اسم الخطة (مثال: قياسية)",
  "Plan your next visit to": "خطط لزيارتك القادمة إلى",
  "Plans": "الخطط",
  "Please add at least one ingredient": "يرجى إضافة مكوّن واحد على الأقل",
  "Please allow popups for printing": "يرجى السماح بالنوافذ المنبثقة للطباعة",
  "Please come again": "نتشرف بزيارتك مجددًا",
  "Please enter a search term": "يرجى إدخال كلمة بحث",
  "Please enter an order code": "يرجى إدخال رمز الطلب",
  "Please enter an order code or PIN": "يرجى إدخال رمز الطلب أو PIN",
  "Please fill in all required admin employee fields": "يرجى تعبئة جميع حقول الموظف المدير المطلوبة",
  "Please fill in all required fields": "يرجى تعبئة جميع الحقول المطلوبة",
  "Please fill in all variant names": "يرجى تعبئة أسماء جميع الخيارات",
  "Please let us know of any allergies before ordering.": "يرجى إخبارنا بأي حساسية قبل الطلب.",
  "Please select a menu item": "يرجى اختيار عنصر من القائمة",
  "Please select a table": "يرجى اختيار طاولة",
  "Please select a valid image file (JPEG, PNG, GIF, WebP)": "يرجى اختيار ملف صورة صالح (JPEG أو PNG أو GIF أو WebP)",
  "Please select a valid image file (JPEG, PNG, WebP, GIF)": "يرجى اختيار ملف صورة صالح (JPEG أو PNG أو WebP أو GIF)",
  "Please select an image first": "يرجى اختيار صورة أولًا",
  "Please use your order code as the transfer reference.": "يرجى استخدام رمز طلبك كمرجع للتحويل.",
  "Please wait, another print is in progress": "يرجى الانتظار، هناك عملية طباعة أخرى جارية",
  "Please wait…": "يرجى الانتظار…",
  "Point of Sale": "نقطة البيع",
  "Points": "النقاط",
  "Points cost": "تكلفة النقاط",
  "Points history": "سجل النقاط",
  "Points issued": "النقاط الممنوحة",
  "Points redeemed": "النقاط المستبدلة",
  "Position": "الترتيب",
  "Position:": "الترتيب:",
  "Powered by Rawaj Business": "بدعم من رواج بزنس",
  "Preparing": "قيد التحضير",
  "Preview": "معاينة",
  "Previewing the first": "معاينة أول",
  "Previous image": "الصورة السابقة"
}
